import script from "./svgIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./svgIcon.vue?vue&type=script&setup=true&lang=ts"

import "./svgIcon.vue?vue&type=style&index=0&id=caece2e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caece2e2"]])

export default __exports__